export async function pollUntil<T>(
  pollFn: () => Promise<T>,
  validateFn: (data: T) => boolean,
  intervalMs: number,
  timeoutMs: number,
): Promise<T> {
  const start = Date.now();

  return new Promise((resolve, reject) => {
    const poll = () => {
      pollFn()
        .then((result) => {
          if (validateFn(result)) {
            resolve(result);
          } else if (Date.now() - start >= timeoutMs) {
            reject(new Error('Timeout exceeded while polling.'));
          } else {
            setTimeout(poll, intervalMs);
          }
        })
        .catch((err) => {
          reject(err);
        });
    };

    poll();
  });
}
